import React, { useEffect, useState } from "react";
import { Col, Placeholder, Row } from "react-bootstrap";
import { Helmet } from "react-helmet";
import { useNavigate, useParams } from "react-router-dom";

import DstButton from "../../components/DstButton/DstButton";
import DstTabs from "../../components/DstTabs/DstTabs";
import { useSession } from "../../contexts/SessionContext";
import translate from "../../services/Translate";
import { completeNavigate } from "../../services/UtilityService";
import { fetchExerciseDetails } from "./Exercise.function";
import MainInfo from "./components/MainInfo/MainInfo";

const Exercise = () => {
  const { exercise_id } = useParams();
  const { language } = useSession();
  const navigate = useNavigate();

  const [activeTab, setActiveTab] = useState("main-infos");

  const [exercise, setExercise] = useState<any>(null);
  const [isLoadedGeneralInfo, setIsLoadedGeneralInfo] = useState(false);

  useEffect(() => {
    fetchExerciseDetails(exercise_id!, setExercise, setIsLoadedGeneralInfo, language);
  }, [exercise_id, language]);

  if (!isLoadedGeneralInfo) {
    return (
      <div className="container-fluid mt-3 mb-5 px-3 px-md-4">
        <Helmet>
          <title>Exercise - {exercise_id}</title>
        </Helmet>

        <div className="d-flex align-items-center mb-3">
          <span className="dst-icon-chevron-left p-2 medium-gray-background rounded me-2" />
          <Placeholder as="h1" animation="glow" className="mb-0 h3 me-3 w-50">
            <Placeholder xs={6} />
          </Placeholder>
        </div>

        <div className="d-flex gap-2 mb-3">
          {[...Array(3)].map((_, index) => (
            <Placeholder
              key={`exercise-mocking-line-${index}`}
              as="div"
              animation="glow"
              className="rounded"
              style={{ width: 140, height: 38 }}
            >
              <Placeholder xs={12} />
            </Placeholder>
          ))}
        </div>

        <Row>
          <Col>
            <Placeholder as="div" animation="glow">
              <Placeholder xs={12} className="mb-2" />
              <Placeholder xs={11} className="mb-2" />
              <Placeholder xs={10} className="mb-2" />
              <Placeholder xs={8} />
            </Placeholder>
          </Col>
          <Col>
            <Placeholder as="div" animation="glow">
              <Placeholder xs={12} className="mb-2" />
              <Placeholder xs={11} className="mb-2" />
              <Placeholder xs={10} className="mb-2" />
              <Placeholder xs={8} />
            </Placeholder>
          </Col>
        </Row>
      </div>
    );
  }

  if (!exercise) {
    return (
      <div className="text-center mt-3">
        <h2>{translate(language, "PAGES.EXERCISE.ERROR.NOT_FOUND")}</h2>
        <DstButton
          value={translate(language, "PAGES.EXERCISE.BUTTONS.ALL_EXERCISES_TITLE")}
          clickFunction={() => navigate("/exercises")}
        />
      </div>
    );
  }

  const tabsData = [
    {
      id: "main-infos",
      title: (
        <React.Fragment>
          <span className="dst-icon-settings-04 me-2" />
          {translate(language, "PAGES.EXERCISE.TABS.MAIN_INFOS")}
        </React.Fragment>
      ),
      content: (
        <MainInfo
          exercise={exercise}
          onRefresh={() => fetchExerciseDetails(exercise_id!, setExercise, setIsLoadedGeneralInfo, language)}
        />
      ),
    },
  ];

  return (
    <div className="container-fluid mt-3 mb-5 px-3 px-md-4">
      <Helmet>
        <title>Exercise - {exercise.name}</title>
      </Helmet>

      <div className="d-flex align-items-center mb-3">
        <span
          className="dst-icon-chevron-left p-2 medium-gray-background rounded me-2 clickable"
          onClick={(event: any) => completeNavigate(event, navigate, "/exercises")}
        />
        <h1 className="mb-0 h3 me-3">{exercise.name}</h1>
      </div>

      <DstTabs
        tabsData={tabsData}
        variant="primary"
        activeKey={activeTab}
        onSelect={(key) => setActiveTab(key || "main-infos")}
      />
    </div>
  );
};

export default Exercise;
